import { WriterValueType } from '../../enums/file-writer/writer-value-type';
import { CsvColumnProps } from '../file-reader/csv-column-props';

/**
 * Defines a single CSV output column. Extends CsvColumnProps (id, columnIndex, columnLabel)
 * with a value source: either a processingData field path or a literal/expression string.
 */
export class CsvWriterColumnProps extends CsvColumnProps {
	/**
	 * How to resolve the column value.
	 * Field=1: read from processingData at the path in `value`.
	 * FreeTextOrExpression=2: treat `value` as a literal string or expression.
	 * @default WriterValueType.Field
	 */
	valueType = WriterValueType.Field;
	/** Field path (when valueType=Field) or literal/expression string (when valueType=FreeTextOrExpression). @default '' */
	value = '';
	constructor(init?: Partial<CsvWriterColumnProps>) {
		super();
		if (init) {
			Object.assign(this, init);
		}
	}
}
